
import React, { useState } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Clock, Bell } from 'lucide-react';
import { useAthleteTaskNotifications } from '@/hooks/useAthleteTaskNotifications';
import TaskReviewModal from './TaskReviewModal';

const TaskNotificationBanner: React.FC = () => {
  const { notifications } = useAthleteTaskNotifications();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (notifications.length === 0) {
    return null;
  }

  return (
    <>
      <Alert className="mb-6 border-orange-200 bg-orange-50">
        <Bell className="h-4 w-4 text-orange-600" />
        <AlertDescription className="flex items-center justify-between">
          <div>
            <span className="font-medium text-orange-800">
              You have {notifications.length} pending task{notifications.length !== 1 ? 's' : ''} from your scout
            </span>
            <span className="text-orange-700 ml-2">
              requiring your review and approval.
            </span>
          </div>
          <Button
            size="sm"
            onClick={() => setIsModalOpen(true)}
            className="bg-orange-600 hover:bg-orange-700 text-white"
          >
            <Clock className="h-4 w-4 mr-1" />
            Review Tasks
          </Button>
        </AlertDescription>
      </Alert>

      <TaskReviewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default TaskNotificationBanner;
